import gql from 'graphql-tag';
import { getClient } from '../../../apollo';

const CheckoutFragment = gql`
    fragment Checkout on Funeral {
        ID
        LegacyID
        LegacyKey
        FirstName
        MiddleName
        Surname
        PlaceOfViewingRequired
        ReadyForMortuary
        MortuaryActionReturnedReason
        DatetimeOfMortuaryCheckout
        DateTransferredToMortuary
        DatetimeReadyForMortuaryCheckout

        Disposal {
            ID
            Date
            Time
            CrematedOrBuried
            IsCoffinSelected
            IsCoffinPrepared
            LocationFlattened
            Location {
                ID
                Name
            }
        }

        Certification {
            ID
            TypeOfBdmDeathCertificate
            Referee {
                ID
            }
        }

        RefereeCremationCheck

        PlaceOfService {
            ID
            Date
            Time
            Type
            LocationFlattened
            Location {
                ID
                Name
            }
        }

        PlaceOfViewingItems {
            ID
            Date
            Time
            Type
            LocationFlattened
            Location {
                ID
                Name
            }
        }

        MortuaryLocation {
            ID
            Name
        }
    }
`;

const CheckoutListQuery = gql`
    ${CheckoutFragment}
    query CheckoutList($offset: Int) {
        readFunerals(mortuary: true, checkout: true, limit: 50, offset: $offset) {
            edges {
                node {
                    ...Checkout
                }
            }
            pageInfo {
                hasNextPage
                totalCount
            }
        }
    }
`;

export const getCheckoutList = (offset = 0) => {
    const variables = { offset };
    return getClient()
        .query({ query: CheckoutListQuery, fetchPolicy: 'network-only', variables })
        .then(
            ({ data }) => {
                const { readFunerals } = data;
                const { hasNextPage, totalCount } = readFunerals.pageInfo || false;
                if (readFunerals) {
                    return {
                        totalCount,
                        hasNextPage,
                        items: readFunerals.edges.map(({ node }) => {
                            return {
                                ...node
                            };
                        })
                    };
                }
            },
            e => {
                console.error('failed to get checkout list', e);
                return { error: 'failed to get checkout list' };
            }
        );
};
